import { VirtualDeviceState } from "./states/virtual-device.state";

export const virtualState = [
    VirtualDeviceState
]